import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../../components/AccountContext';
import JobProfileSurveyList from './JobProfileSurveyList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query($accountId: ID!, $jid: ID!, $first: Int, $after: String, $last: Int, $before: String) {
    account(id: $accountId) {
      id
      jobProfile(id: $jid) {
        id
        jobProfileSurveys(first: $first, after: $after, last: $last, before: $before) {
          totalCount
          indexFrom
          indexTo
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          edges {
            node {
              id
              status
              createdOn
              updatedOn
              respondent {
                id
                firstName
                lastName
                email
              }
            }
          }
        }
      }
    }
  }
`;

class JobProfileSurveyListContainer extends Component {
  render() {
    const {
      currentAccount, location, translatedTags, match,
    } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const { jobProfileId } = match.params;
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort,
      filter: params.filter,
      jid: jobProfileId,
    };
    return (
      <Query query={LIST_QUERY} variables={variables}>
        {({ data, loading, error }) => {
          if (error) {
            return `Error! ${error.message}`;
          }

          const connection = data && data.account && data.account.jobProfile
            ? data.account.jobProfile.jobProfileSurveys
            : emptyConnection();
          return (
            <JobProfileSurveyList
              connection={connection}
              currentAccount={currentAccount}
              translatedTags={translatedTags}
              loading={loading}
            />
          );
        }}
      </Query>
    );
  }
}

JobProfileSurveyListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapState,
      null,
    )(withAccount(JobProfileSurveyListContainer)),
  ),
);
